import { cn } from "@/lib/utils"
import type { PropsWithChildren } from "react"

interface IzzySpeechBubbleProps extends PropsWithChildren {
  className?: string
}

export const IzzySpeechBubble = ({ children, className }: IzzySpeechBubbleProps) => {
  return (
    <div className={cn('border bg-background text-xs border-[var(--brand-blue-2)] text-[var(--brand-blue-2)] rounded-t-xl rounded-br-xl p-3', className)}>
      {children}
    </div>
  )
}
